var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "credentials-box container" }, [
    _c("div", { staticClass: "row header" }, [
      _c("span", [_vm._v("\n      " + _vm._s(_vm.$t(_vm.getLabel)) + "\n    ")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "body" }, [
          _c(
            "div",
            { staticClass: "shop-image" },
            [
              _vm.isIcon
                ? _c(
                    "div",
                    { staticClass: "icon-background" },
                    [
                      _c("q-icon", {
                        staticClass: "image",
                        attrs: {
                          allowSelfUpdate: false,
                          width: "24px",
                          pack: _vm.getIconPack,
                          name: _vm.getIconName
                        }
                      })
                    ],
                    1
                  )
                : _c("q-image", {
                    staticClass: "image",
                    attrs: { pack: _vm.getIconPack, name: _vm.getIconName }
                  })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "actions-container" },
            [_vm._t("actions")],
            2
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e4d24ee", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e4d24ee","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/display/CredentialsBox.vue
// module id = null
// module chunks = 